// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_close--gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__accountsTable____fs7t {
  width: 50%;
}

.styles__link___V94Bg {
  margin-bottom: 20px;
  margin-right: 20px;
}

.styles__contentContainer____fsJx {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 0;
  padding-top: 20px;
}

.styles__contentContainer____fsJx:before {
  content: '';
  display: table;
}

.styles__contentContainer____fsJx:after {
  content: '';
  display: table;
  clear: both;
}

.styles__section___RGnkp {
  margin-bottom: 20px;
}

.styles__sectionTitle____O4zz {
  margin-bottom: 20px;
}

.styles__formWrapper___cjYlR {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__formWrapper___cjYlR:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__formWrapper___cjYlR:last-child {
  margin-right: 0;
}

.styles__formWrapper___cjYlR:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__formWrapper___cjYlR:nth-child(3n + 1) {
  clear: both;
}

.styles__twoThird___J3Qny {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__twoThird___J3Qny:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__twoThird___J3Qny:last-child {
  margin-right: 0;
}

.styles__twoThird___J3Qny:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__twoThird___J3Qny:nth-child(3n + 1) {
  clear: both;
}

.styles__oneThird___GF0qd {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird___GF0qd:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird___GF0qd:last-child {
  margin-right: 0;
}

.styles__oneThird___GF0qd:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird___GF0qd:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird___GF0qd {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird___GF0qd:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird___GF0qd:last-child {
    margin-right: 0;
}

.styles__oneThird___GF0qd:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird___GF0qd:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__row___ZD5LM {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.styles__navigationMenuWrapper___gvwmv {
  position: fixed;
  width: 452.86px;
}

@media (max-width: 1440px) {

.styles__navigationMenuWrapper___gvwmv {
    max-width: 31%;
    right: 20px;
}
  }

.styles__titleSection___oFMT6 {
  position: relative;
}

.styles__titleSection___oFMT6:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___oFMT6 .styles__name___rgIwD {
    font-size: 18px;
    transition: all 0.25s;
  }

.styles__titleSection___oFMT6 .styles__noName___HHk_d {
    margin-top: 2px;
  }

.styles__formItemMono___XYGkK {
}

.styles__input___GLz0I {
}

.styles__inputWrapper___LH3GN {
  position: relative;
  display: flex;
  margin: 0 0 10px;
  width: 240px;
}

.styles__label___Kfkuz {
}

.styles__remove___GXB69 {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: 14px;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: pointer;
  transition: opacity 0.2s;
}

.styles__remove___GXB69 a {
    display: block;
    box-shadow: none;
    height: 20px;
    width: 20px;
  }

.styles__clearIcon___uPyg6 {
  position: absolute;
  top: 12px;
  right: 16px;
  width: 10px;
  color: #ccc;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/SuspendedAccts/components/Main/styles.css"],"names":[],"mappings":"AAIA;EACE,UAAU;AACZ;;AAEA;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,iBAAiB;EACjB,iBAAiB;AACnB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AAMjB;;AAJE;;AAJF;IAKI,cAAc;IACd,WAAW;AAEf;EADE;;AAGF;EAEE,kBAAkB;AAcpB;;AAZE;IACE,mBAAmB;EACrB;;AAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;AAEA;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;AAEA;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAwD;EACxD,eAAe;EACf,wBAAwB;AAQ1B;;AANE;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;AAGF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,eAAe;AACjB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGray, gtGreen, gtBackground from colors;\n\n.accountsTable {\n  width: 50%;\n}\n\n.link {\n  composes: buttonSecondary from helpers;\n  margin-bottom: 20px;\n  margin-right: 20px;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 0;\n  padding-top: 20px;\n}\n\n.section {\n  composes: section from helpers;\n  margin-bottom: 20px;\n}\n\n.sectionTitle {\n  margin-bottom: 20px;\n}\n\n.formWrapper {\n  lost-column: 2/3;\n}\n\n.twoThird {\n  lost-column: 2/3;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.navigationMenuWrapper {\n  position: fixed;\n  width: 452.86px;\n\n  @media (max-width: 1440px) {\n    max-width: 31%;\n    right: 20px;\n  }\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    font-size: 18px;\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.formItemMono {\n  composes: formItemMono from helpers;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  margin: 0 0 10px;\n  width: 240px;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.remove {\n  height: 20px;\n  width: 20px;\n  background-position: center;\n  background-size: 14px;\n  background-repeat: no-repeat;\n  background-image: url('styles/img/icon_close--gray.png');\n  cursor: pointer;\n  transition: opacity 0.2s;\n\n  a {\n    display: block;\n    box-shadow: none;\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.clearIcon {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  width: 10px;\n  color: #ccc;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBackground": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBackground"]}`,
	"accountsTable": `styles__accountsTable____fs7t`,
	"link": `styles__link___V94Bg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"contentContainer": `styles__contentContainer____fsJx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"section": `styles__section___RGnkp ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionTitle": `styles__sectionTitle____O4zz`,
	"formWrapper": `styles__formWrapper___cjYlR`,
	"twoThird": `styles__twoThird___J3Qny`,
	"oneThird": `styles__oneThird___GF0qd`,
	"row": `styles__row___ZD5LM`,
	"navigationMenuWrapper": `styles__navigationMenuWrapper___gvwmv`,
	"titleSection": `styles__titleSection___oFMT6 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___rgIwD`,
	"noName": `styles__noName___HHk_d`,
	"formItemMono": `styles__formItemMono___XYGkK ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemMono"]}`,
	"input": `styles__input___GLz0I ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"inputWrapper": `styles__inputWrapper___LH3GN`,
	"label": `styles__label___Kfkuz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"remove": `styles__remove___GXB69`,
	"clearIcon": `styles__clearIcon___uPyg6`
};
export default ___CSS_LOADER_EXPORT___;
